export default "__VITE_ASSET__DUThePDH__"